export default __webpack_public_path__ + "static/media/Ficha Técnica - Manga Tommy integral asséptica.08187042.pdf";